import { useState } from 'react'
import { Block } from "../../components/Block/Block"
import { Container } from "../../components/Container/Container"
import { Header } from "../../components/Header/Header"
import { RenderRegistrationComponent } from "./RenderRegistrationComponent";
import { PageProgress } from "./Components/PageProgress/PageProgress";
import { Spinner } from "../../components/Spinner/Spinner";
import { useNavigate, useParams, useSearchParams } from "react-router";
import { useRegistrationData } from "../../providers/RegistrationDataProvider/useRegistrationData";
import { RegistrationSectionProvider } from "../../providers/RegistrationSectionProvider/Provider";
import styles from './Registration.module.scss';
import cn from "classnames";
import { useEffect } from "react";
import { conversionApi } from "../../services/conversionApi";
import { useUserData } from "../../providers/UserDataProvider/useUserData";
import { getSubscriptionData } from '../../services/getSubscriptionData';
const Registration = ({theme='light' })=>{
  const { id } = useParams();
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get('session_id') || localStorage.getItem('sessionID') || null;
  const paypalId = searchParams.get('paypal_id') || localStorage.getItem('paypal_id') || null;
  const [sessionInfo,setSessionInfo] = useState(null);
  const planInfo = JSON.parse(localStorage.getItem('planInfo'));
  const { userData } = useUserData();
  const navigate = useNavigate();
  const email = userData?.email;
  const currency = localStorage.getItem('currency') || 'usd';
  // const { data, setData } = useRegistrationData();
  const { data } = useRegistrationData();
  const currentIndex = data?.findIndex((item) => item.slug === id);
  const boxItem = data?.[currentIndex];
  const nextItem = data?.[currentIndex + 1] || null;
  const registrationPrefix = '/registration/';
  const toRegistrationPath = (slug) =>
    slug.startsWith('/') ? slug : registrationPrefix + slug;
  const nextSlug = nextItem ? toRegistrationPath(nextItem.slug) : '/registration/finish';

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [id]);
  useEffect(() => {
    if(theme) {
      document.body.setAttribute('data-theme', theme);
    }else {
      document.body.removeAttribute('data-theme');
    }
  }, [theme]);

  useEffect(() => {
    if (sessionId){
      if(localStorage.getItem('sessionID') !== sessionId){
        localStorage.setItem('sessionID', sessionId)
      }
      const fetchData = async () => {
        const { data, error } = await getSubscriptionData(sessionId);
        setSessionInfo(data);
        if (error) {
          console.error('error:', error);       
        }
        if (!error) {
          conversionApi(data, planInfo, email); // Используй только что полученные данные!
        }
      };
      fetchData();
    }
    if(paypalId){
      if(localStorage.getItem('paypal_id') !== paypalId){
        localStorage.setItem('paypal_id', paypalId)
      }
   
      const data = {
        subscription :{
          currency: currency,
          id: paypalId,
          type: "paypal"
        },
        customer: {
          email: email,
          id: btoa(email)
        }
      }
      setSessionInfo(data);
      conversionApi(data, planInfo, email);
    }

  }, [sessionId,paypalId]);


  // QA-97: an account already made in this browser is not asked for again (back button, reload).
  useEffect(() => {
    if (boxItem?.type === 'RegistrationBlock' && userData?.registration === 'completed') {
      navigate(nextSlug, { replace: true });
    }
  }, [boxItem, userData, nextSlug]);

  useEffect(() => {
    if (
      boxItem &&
      (boxItem.subscriptionData || boxItem.upsaleKey) &&
      userData &&
      userData.upsale
    ) {
      const upsaleKey = boxItem.subscriptionData?.upsaleKey || boxItem.upsaleKey;
      if (userData.upsale[upsaleKey] === 'paid') {
        navigate(nextSlug);
      }
    }
  }, [boxItem, userData, nextSlug]);
  if (!data) {
    return <Spinner />;
  }
 
  // const currentIndex = data.findIndex((item) => item.slug === id);
  // const boxItem = data[currentIndex];
  // const nextItem = data[currentIndex + 1] || null;
  // const registrationPrefix = '/registration/';
  // const toRegistrationPath = slug => 
  //   slug.startsWith('/') ? slug : registrationPrefix + slug;
  // const nextSlug = nextItem ? toRegistrationPath(nextItem.slug) : '/registration/finish';


  
  return (
    <>
    <Header style={boxItem.headerStyle || null} nextSlug={boxItem.headerType === 'offer' ? nextSlug : null}/>
    <Block className={cn(
      styles.block,
      boxItem.headerType==="download" && styles.gradientBackground
    )}>
      <Container>
        <PageProgress status={boxItem} style={boxItem.headerStyle || null}/>
        <RegistrationSectionProvider {...{ boxItem, nextSlug, sessionInfo, planInfo }}>
          {RenderRegistrationComponent({ boxItem})}
        </RegistrationSectionProvider>
      </Container>
    </Block>
    </>
  );
}
export default Registration;

